import * as React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { apiRequest } from '../../../APIClient';
import { onboardingSelector } from '../../../reducers/onboarding';
import { sessionSelector } from '../../../reducers/session';

type Props = {};

export const OnboardingConnectWiseIntegrationConfig: React.FC<Props> = ({}) => {
  const canEdit = useSelector(sessionSelector.canEditOnboarding);
  const siteSection = useSelector(onboardingSelector.getSitesSection);
  const [configureConnectWise, setConfigureConnectWise] = React.useState(
    () => siteSection.configureConnectWise,
  );
  const dispatch = useDispatch();
  const onChange = React.useCallback(
    (e) => {
      const newValue = e.currentTarget.checked;
      setConfigureConnectWise(newValue);
      dispatch(
        apiRequest.updateOBSiteSection({
          ...siteSection,
          configureConnectWise: e.currentTarget.checked,
        }),
      );
    },
    [dispatch, setConfigureConnectWise],
  );

  React.useEffect(() => {
    setConfigureConnectWise(siteSection.configureConnectWise);
  }, [siteSection]);
  return (
    <FormGroup className="pl-2">
      <div className="pt-3">
        <Label className="ob-accordion-checkbox" check>
          <Input
            type="checkbox"
            id="configureConnectWise"
            checked={configureConnectWise}
            onChange={onChange}
            disabled={!canEdit}
          />
          Please check if either scenario applies:
          <ul>
            <li>
              Internal Setup: My organization needs to setup ConnectWise
              internally.
            </li>
            <li>
              End User: My organization would like to setup an End User account
              using ConnectWise.
            </li>
          </ul>
        </Label>
      </div>
      <div className="pt-1">
        If you would like to learn more about ConnectWise please view{' '}
        <a
          href="https://docs.arcticwolf.com/csh?topicname=configure_connectwise_to_integrate_with_arctic_wolf.html"
          target="_target"
        >
          this guide.
        </a>
      </div>
    </FormGroup>
  );
};

export default OnboardingConnectWiseIntegrationConfig;
